import { Component, OnInit } from '@angular/core';
import { ApiRestService } from './services/network/api-rest.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private apiRestService: ApiRestService, private router: Router) { }
  readonly REFRESH_INTERVAL_MS = 30_000; // cada 30 segundos
  readonly EXPIRATION_BUFFER_S = 90; // 1.5 minutos
  private isRefreshing = false;

  ngOnInit(): void {
    // Revisión inicial
    if (this.apiRestService.getToken() != null) {
      // Revisar si expira en menos de 1 minuto
      if (this.apiRestService.timeToExpire() < this.EXPIRATION_BUFFER_S) {
        this.apiRestService.updateToken();
      }
    } else {
      if (!document.location.href.includes('appinfo/privacy')) {
        this.apiRestService.getRouter().navigate(['/auth/login']);
      }
    }

    setInterval(() => {
      const token = this.apiRestService.getToken();
      if (token && !this.isRefreshing) {
        const tte = this.apiRestService.timeToExpire();
        if (tte < this.EXPIRATION_BUFFER_S) {
          this.isRefreshing = true;
          this.apiRestService.updateToken();
          setTimeout(() => (this.isRefreshing = false), 3000); // espera para no repetir
        }
      }
    }, this.REFRESH_INTERVAL_MS);
  }
}
